// extracted by mini-css-extract-plugin
module.exports = {"entityName":"highlight-copy_entityName__zE38Z","entityNameBold":"highlight-copy_entityNameBold__OQIUO"};